import React from "react"
import styles from "./timeline-item.module.css"
import TimelineTag from "@/components/timeline/timeline-tag/timeline-tag.tsx"
import { CalendarActivityState } from "@/features/gestational-calendar/types/calendar-types.ts"
import { BROWN, CALVING_COLOR } from "@/utils/constants/colors-constants.ts"

interface TimeLineItemProps {
  activityState: CalendarActivityState
  completionPercentage?: number
  isLast: boolean
  isAfterCalving?: boolean
  isAfterAbortion?: boolean
  children?: React.ReactNode
}

const TimelineItem: React.FC<TimeLineItemProps> = ({
  activityState,
  isLast,
  children,
  isAfterAbortion,
  isAfterCalving,
  completionPercentage,
}) => {
  const coloredRodStyle = {
    height:
      completionPercentage &&
      activityState !== CalendarActivityState.ABORTED &&
      !isAfterAbortion
        ? `${completionPercentage}%`
        : 0,
  }

  const isDoneAndBeforeCalving =
    activityState === CalendarActivityState.DONE &&
    !completionPercentage &&
    !isAfterCalving

  const isDoneAndAfterCalving =
    activityState === CalendarActivityState.DONE &&
    !completionPercentage &&
    isAfterCalving

  const getRodBackgroundColor = () => {
    if (
      completionPercentage == 0 ||
      activityState == CalendarActivityState.ABORTED ||
      isAfterAbortion
    )
      return

    if (isDoneAndBeforeCalving) {
      return BROWN
    } else if (isDoneAndAfterCalving) {
      return CALVING_COLOR
    }
  }

  return (
    <div className={styles.timeLineItemWrapper}>
      <div className={styles.connectorWrapper}>
        <TimelineTag
          activityState={activityState}
          isAfterCalving={isAfterCalving}
        />
        {!isLast && (
          <div
            className={styles.rod}
            style={{
              backgroundColor: getRodBackgroundColor(),
              opacity: 1,
            }}
          >
            <div
              className={styles.coloredRod}
              data-is-after-calving={isAfterCalving}
              style={coloredRodStyle}
            ></div>
          </div>
        )}
      </div>
      <div className={styles.itemWrapper}>{children}</div>
    </div>
  )
}

export default TimelineItem
